import { Coluna, Exercicio, FormatoExportacao, FuncaoService, GlobalService, Login, Relatorio } from "eddydata-lib";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Injector } from "@angular/core";
import { Assinaturas } from "administrativo-lib";
import { QuadroEnsinoService } from "contabil-lib";

type DadosReceita = {
    mes: number;
    anterior?: number;
    atual?: number;
}

type DadosDespesa = {
    mes: number;
    empenhada?: number;
    liquidada?: number;
}

export class ReceitaEDespesaDoEnsinoPublicacao {
    protected unsubscribe: Subject<void> = new Subject();
    protected login: Login = new Login();
    protected funcaoService: FuncaoService;
    protected globalService: GlobalService;

    public valorRepasseTotal: number = 0;
    public valorRendimentosTotal: number = 0;

    //Antes Resumo
    public projecaoReceita: number = 0;
    public despesaEmpenhada: number = 0;
    public projecaoRendimento: number = 0;
    public projecaoDespesaLiquidada: number = 0;
    public saldoGeral: number = 0;
    public saldoResto: number = 0;
    public valorNaoLiquidadoObra: number = 0;
    public totalProvisionadoPorcentagem: number = 0;
    public valorNaoLiquidadoObraPorcentagem: number = 0;

    //Resumo Financeiro
    public saldoConta: number = 0;
    public saldoRelacaoEmpenhada: number = 0;
    public saldoRelacaoPgtResto: number = 0;
    public saldoRelacaoPgt: number = 0;

    constructor(
        protected quadroServico: QuadroEnsinoService,
        protected dataInicial: Date,
        protected dataFinal: Date,
        protected despesaComRendimento: boolean,
        protected considerarQSE: boolean,
        protected injector?: Injector,
        protected assinatura_ensino?: boolean
    ) {
        this.globalService = new GlobalService();
        this.funcaoService = new FuncaoService();
        this.login = GlobalService.obterSessaoLogin();
    }

    public async montarRelatorio(orgaos: number[], formato: FormatoExportacao) {
        this.quadroServico.obterReceitaDepesaEnsinoPublicacao(orgaos, this.dataInicial, this.dataFinal, this.despesaComRendimento, this.considerarQSE)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(async dados => {
                if (formato === 'pdf') {

                    Relatorio.imprimirPersonalizado(
                        'RECEITAS E DESPESAS DO ENSINO - PUBLICAÇÃO (ARTIGO 256 DA CONSTITUIÇÃO ESTADUAL)',
                        this.login?.usuario?.nome,
                        this.login?.usuario?.sobrenome,
                        this.login?.orgao?.nome,
                        this.login?.orgao?.brasao?.brasao,
                        await this.montarConteudo(dados),
                        "landscape",
                        'RECEITAS E DESPESAS DO ENSINO - PUBLICAÇÃO',
                        {
                            linhas: {
                                hLineWidth() { return 1 },
                                vLineWidth() { return 1 },
                                hLineColor() { return 'black' },
                                paddingLeft() { return 3 },
                                paddingRight() { return 3 }
                            }
                        }, false, false, 'pdf'
                    );
                    // } else {
                    //             this.funcaoService.exportar(formato, this.conteudoExportar(dados), 'PROJEÇÃO DO QSE', this.colunasRelatorio())
                }
            });
    }

    private async montarConteudo(dados: any) {
        const conteudo = [];

        dados[0]['total_receitas'] = +dados[0]['iptu'] + +dados[0]['bens_imoveis'] + +dados[0]['servico_natureza'] + +dados[0]['retito_fonte'] + +dados[0]['divida_ativa'] + +dados[0]['atualizacao_divida'] + +dados[0]['multas_juros'] + +dados[0]['fundo_participacao'] + +dados[0]['territorio_rural'] + +dados[0]['desoneracao_lc8796'] + +dados[0]['mercadorias_servicos'] + +dados[0]['veiculo_automotor'] + +dados[0]['produto_sem_exportacao'];

        dados[0]['total_fundeb'] = +dados[0]['recebidos_fundeb'] + +dados[0]['redimentos_fundeb'];

        dados[0]['sub_total_fundeb'] = dados[0]['total_fundeb'] + +dados[0]['fundeb_anterior'];

        dados[0]['total_recursos'] = +dados[0]['qse_convenio'] + +dados[0]['aplicacao_ldb'];

        dados[0]['total_aplicado_convenio'] = dados[0]['sub_total_fundeb'] + dados[0]['total_recursos'];

        dados[0]['total_despesa'] = +dados[0]['receitas_impostos'] + +dados[0]['convenio_transferencia'] + +dados[0]['superavit_financeiro'];

        dados[0]['total_despesa_recursos'] = +dados[0]['receitas_impostos'] + +dados[0]['rendimentos_ldb'];

        dados[0]['total_aplicado'] = +dados[0]['recebidos_fundeb'] + +dados[0]['redimentos_fundeb'];

        dados[0]['total_fundeb_atual'] = +dados[0]['fundeb_magistrado'] + +dados[0]['fundeb_outras'];

        dados[0]['total_fundeb_aplicado'] = dados[0]['total_fundeb_atual'] + +dados[0]['fundeb_anterior'];

        dados[0]['total_receita'] = +dados[0]['efetivamento_fundeb'] - +dados[0]['recebidos_fundeb'];

        dados[0].fundeb_nao_aplicado = dados[0]['total_fundeb_atual'] < +dados[0]['efetivamento_fundeb'] ? +dados[0]['total_fundeb_atual'] - +dados[0]['efetivamento_fundeb'] : 0;

        dados[0]['ganho_liquido'] = dados[0]['total_fundeb_aplicado'] - +dados[0]['efetivamento_fundeb'];

        dados[0]['total_ensino'] = (+dados[0].receitas_impostos - +dados[0].rendimentos_ldb + +dados[0].recebidos_fundeb + +dados[0].fundeb_nao_aplicado + (+dados[0].efetivamento_fundeb - +dados[0].recebidos_fundeb) - +dados[0].despesa_fundeb_anterior);

        dados[0]['aplicacao_ensino'] = (dados[0].total_ensino / dados[0].total_receitas) * 100;

        if (this.considerarQSE) {
            conteudo.push([
                {
                    text: `MUNICÍPIO: ${this.login.cidade.nome.toLocaleUpperCase()}`,
                    bold: true, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }, {
                    text: `PERÍODO: ${this.funcaoService.converteDataBR(this.dataInicial)} À ${this.funcaoService.converteDataBR(this.dataFinal)}`,
                    bold: true, colSpan: 3, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }, '', '',
                {
                    text: ``,
                    bold: true, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `RECEITAS ARRECADADAS`,
                    bold: true, alignment: 'left', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `Acumulado`,
                    bold: true, alignment: 'center', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `DESPESAS DO ENSINO`,
                    bold: true, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: `Acumulado`,
                    bold: true, alignment: 'center', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto Predial Territorial Urbano - IPTU`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].iptu),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.122 - Administração Geral da Secretaria de Educação`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].receitas_impostos),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Transmissão de Bens Imóveis`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].bens_imoveis),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.361 - Ensino Fundamental`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].convenio_transferencia),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Serviços de Qualquer Natureza`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].servico_natureza),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.362 - Ensino Médio`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto de Renda Retido na Fonte`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].retito_fonte),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.365 - Ensino Infantil`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].ensino_infantil),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Dívida Ativa de Impostos`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].divida_ativa),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.366 - Educação de jovens e Adultos`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Atualização de Dívida Ativa de Impostos`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].atualizacao_divida),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `12.367 - Educação Especial`, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Multas/juros provenientes de impostos`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].multas_juros),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) Total da Depesa do Ensino`,
                    bold: true, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(+dados[0].convenio_transferencia + +dados[0].receitas_impostos + +dados[0].ensino_infantil),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Fundos de Participação dos Municípios`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundo_participacao),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Despesa c/ Recursos do QSE, Convẽnios e Outros`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto Território Rural`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].territorio_rural),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Despesa c/ Rendimentos de Aplicação - Conta LDB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].rendimentos_ldb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Desoneração de Exportações (LC-87/96)`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].desoneracao_lc8796),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) Total da Despesa com Recursos Próprios`,
                    bold: true, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(+dados[0].convenio_transferencia + +dados[0].receitas_impostos + +dados[0].ensino_infantil), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Circulação de Mercadorias e Serviços`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].mercadorias_servicos),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(+) Despesas realizadas com Recursos do FUNDEB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Propriedade de Veículo Automotor`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].veiculo_automotor),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(+) Valor Efetivamente Retido ao FUNDEB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Produto Industrial s/ Exportação`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].produto_sem_exportacao),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Parcela Empenhada do Ganho Líquido - FUNDEB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `TOTAL DAS RECEITAS DE IMPOSTOS E TRANSFERÊNCIAS`, bold: true, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_receitas), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) TOTAL APLICADO DO ENSINO`, bold: true,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_aplicado_qse), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: ``, bold: true, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``, bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `APLICAÇÃO NO ENSINO (ATR. 212 CF)`, bold: true,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_magistrado) + '%', bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `QSE, Convênios e Outros Recursos Adicionais`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].qse_convenio),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Rendimentos de Aplicação Financeira - Conta LDB e Adicionais`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].aplicacao_ldb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB`, bold: true,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Recursos de Operações de Crédito`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `Aplicação dos recurso recebidos do FUNDEB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_outras) + `%`,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Recursos recebidos do FUNDEB`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].recebidos_fundeb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `Aplicação nos profissionais do Magistério - FUNDEB`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber((+dados[0].aplicacao_magisterio_empenho / +dados[0].aplicacao_magisterio_recebido * 100)) + `%`,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Rendimentos de Aplicação Financeira do FUNDEB`, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].redimentos_fundeb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `TOTAL DOS RECURSOS ADICIONAIS`, bold: true, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_recursos), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: ``, alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `TOTAL DA RECEITA ARRECADADA`, bold: true, alignment: 'left', fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(+dados[0].total_aplicado_convenio + dados[0].total_receitas), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `REPASSE À CONTA DO ENSINO - ART.69 5, LEI 9.394/96`, bold: true,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0), bold: true,
                    alignment: 'right', fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                }
            ]);
        } else {

            conteudo.push([
                {
                    text: `DESPESAS LIQUIDADAS`,
                    bold: true, colSpan: 5, alignment: 'center', fontSize: 6, border: [false, false, false, false], margin: [0, -15, 0, 0]
                }, '', '', '', '',
            ]);

            conteudo.push([
                {
                    text: `MUNICÍPIO: ${this.login.cidade.nome.toLocaleUpperCase()}`,
                    bold: true, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }, {
                    text: `PERÍODO: ${this.funcaoService.converteDataBR(this.dataInicial)} À ${this.funcaoService.converteDataBR(this.dataFinal)}`,
                    bold: true, colSpan: 3, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }, '', '',
                {
                    text: ``,
                    bold: true, alignment: 'left', fontSize: 6, border: [false, false, false, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `RECEITAS ARRECADADAS`,
                    bold: true, alignment: 'left', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `Acumulado`,
                    bold: true, alignment: 'center', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `DESPESAS DO ENSINO`,
                    bold: true, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: `Acumulado`,
                    bold: true, alignment: 'center', fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto Predial Territorial Urbano - IPTU`,
                    bold: true, alignment: 'left', fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].iptu),
                    alignment: 'right', fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `Departamento de Educação Básica - Receita de Impostos`,
                    bold: true, alignment: 'left', colSpan: 2, fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].receitas_impostos),
                    alignment: 'right', fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                }
            ]);


            conteudo.push([
                {
                    text: `Imposto s/ Transmissão de Bens Imóveis`,
                    alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].bens_imoveis),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `Departamento de Educação Básica - Convênios / Transferências`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].convenio_transferencia),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Serviços de Qualquer Natureza`,
                    alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].servico_natureza),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `Departamento de Educação Básica - Superávit Financeiro`,
                    alignment: 'left', colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].superavit_financeiro),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto de Renda Retido na Fonte`,
                    alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].retito_fonte),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) Total da Despesa do Ensino`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_despesa),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Divida Ativa de Impostos`,
                    alignment: 'left', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].divida_ativa),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Despesa c/ Recursos do QSE, Convênios e Outros`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].despesa_qse),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Atualização de Dívida Ativa de Impostos`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].atualizacao_divida),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Despesa c/ Rendimentos de Aplicação - Conta LDB`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].rendimentos_ldb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Multa/Juros provenientes de impostos`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].multas_juros),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Despesa c/ Recursos de Operações de Crédito`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Fundo de Participação dos Municípios`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundo_participacao),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) Total da Despesa com Recursos Próprios`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_despesa_recursos),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto Territorial Rural`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].territorio_rural),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(+) Despesas FUNDEB / Aplic. Financeira / Desp. Ex. Anterior`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].despesa_fundeb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Desoneração de Exportações (LC-86/66)`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].desoneracao_lc8796),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(+) Valor Efetivamento Retido FUNDEB`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].efetivamento_fundeb),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Circulação de Mercadorias e Serviços`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].mercadorias_servicos),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(+) Parcela Empenhada do Ganho Líquido - FUNDEB`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].ganho_liquido),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Propriedade de Veículo Automotor`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].veiculo_automotor),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(-) Fundeb Retido e Não Aplicado`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_nao_aplicado),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Imposto s/ Produto Industrial s/ Exportação`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].produto_sem_exportacao),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: '',
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `TOTAL DAS RECEITAS DE IMPOSTOS E TRANSFERÊNCIAS`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_receitas),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `(=) TOTAL APLICADO NO ENSINO`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_ensino),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `MÍNIMO A SER APLICADO ( 25% ) `,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_receitas * 0.25),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `APLICAÇÃO NO ENSINO (ART.212 CF)`,
                    alignment: 'left', bold: true, colSpan: 2, fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].aplicacao_ensino) + '%',
                    alignment: 'right', bold: true, fontSize: 6, border: [true, true, true, true], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `QSE, Convênios e Outros Recursos Adicionais`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['qse_convenio']),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB`,
                    alignment: 'center', bold: true, colSpan: 2, fontSize: 6, border: [true, true, false, true], margin: [0, 0, 0, 0]
                }, '',
                {
                    text: '',
                    alignment: 'right', bold: true, fontSize: 6, border: [false, true, true, true], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Rendimentos de Aplicação Financeira - Conta LDB e Adicionais`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['aplicacao_ldb']),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `100%`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB - TOTAL A SER APLICADO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_aplicado),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Recursos de Operações de Crédito`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(0),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `${this.funcaoService.convertToBrNumber((+dados[0].fundeb_magistrado / (+dados[0].recebidos_fundeb + +dados[0].redimentos_fundeb)) * 100)}%`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB - PESSOAL MAGISTÉRIO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_magistrado),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Recursos recebidos do FUNDEB`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['recebidos_fundeb']),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `${this.funcaoService.convertToBrNumber((+dados[0].fundeb_outras / (+dados[0].recebidos_fundeb + +dados[0].redimentos_fundeb)) * 100)}%`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB - OUTRAS DESPESAS`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_outras),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `Rendimentos de Aplicação Financeira do FUNDEB`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['redimentos_fundeb']),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `${this.funcaoService.convertToBrNumber(((+dados[0].fundeb_magistrado + +dados[0].fundeb_outras) / (+dados[0].recebidos_fundeb + +dados[0].redimentos_fundeb)) * 100)}%`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `TOTAL APLICADO DO FUNDEB DO EXERCÍCIO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_fundeb_atual),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `RECEITA TOTAL DO FUNDEB `,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['total_fundeb']),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB - EXERCÍCIOS ANTERIORES`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].fundeb_anterior),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `FUNDEB - Exercícios Anteriores `,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['fundeb_anterior']),
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: ``,
                    alignment: 'right', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `TOTAL FUNDEB APLICADO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_fundeb_aplicado),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `SUB TOTAL FUNDEB`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['sub_total_fundeb']),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(a)`,
                    alignment: 'center', fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `RECEITA FUNDEB`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].recebidos_fundeb),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, true, true, false], margin: [0, 0, 0, 0]
                }
            ]);

            conteudo.push([
                {
                    text: `TOTAL DOS RECURSOS ADICIONAIS`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['total_recursos']),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `(b)`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB RETIDO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].efetivamento_fundeb),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, false], margin: [0, 0, 0, 0]
                }
            ]);


            conteudo.push([
                {
                    text: `TOTAL REC. CONVENIOS A SER APLICADO`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0]['total_aplicado_convenio']),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `(b-a)`,
                    alignment: 'center', fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: `FUNDEB EFETIVAMENTE RETIDO RECEITA`,
                    alignment: 'left', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                },
                {
                    text: this.funcaoService.convertToBrNumber(dados[0].total_receita, 2, true),
                    alignment: 'right', bold: true, fontSize: 6, border: [true, false, true, true], margin: [0, 0, 0, 0]
                }
            ]);
        }

        let assinaturas
        if (this.assinatura_ensino) {
            const ass = new Assinaturas(this.login.orgao, this.injector);
            assinaturas = await ass.dadosAssinatura(25, false, null, false, this.assinatura_ensino);
        }

        return this.assinatura_ensino ? [{
            layout: 'linhas',
            table: {
                widths: ['*', 'auto', 'auto', '*', 'auto'],
                body: conteudo
            }
        }, {
            layout: 'linhas',
            table: {
                dontBreakRows: true,
                headerRows: 0,
                widths: ['*', '*', '*'],
                body: assinaturas
            }
        }] : [{
            layout: 'linhas',
            table: {
                widths: ['*', 'auto', 'auto', '*', 'auto'],
                body: conteudo
            }
        }];

    }
}